var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1551,
    y: 619,
    width: 435,
    height: 120,
    fill: "url(#paint0_linear_503_45)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1551,
    cy: 679,
    r: 60,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 325,
    height: 120,
    transform: "matrix(-1 0 0 1 2227 979)",
    fill: "url(#paint1_linear_503_45)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    transform: "matrix(-1 0 0 1 2287 979)",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 120,
    transform: "matrix(-1 0 0 1 2037 1159)",
    fill: "url(#paint2_linear_503_45)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    transform: "matrix(-1 0 0 1 2097 1159)",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1711,
    y: 799,
    width: 275,
    height: 120,
    fill: "url(#paint3_linear_503_45)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1711,
    cy: 859,
    r: 60,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1661,
    y: 1339,
    width: 342,
    height: 120,
    fill: "url(#paint4_linear_503_45)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1661,
    cy: 1399,
    r: 60,
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1180.56 615.934C1207.91 632.426 1234.78 640.394 1247.4 637.141C1279.03 628.984 1281.94 513.219 1257.46 467.58C1232.99 421.941 1107.18 402.049 1100.83 492.474C1098.63 523.857 1111.8 551.865 1131.27 574.719L1096.37 737.437H1197.73L1180.56 615.934Z",
    fill: "#EAC7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1302.37 404.312C1300.27 396.93 1294.62 390.61 1287.01 388.735C1285.17 388.28 1283.26 388.097 1281.37 388.173C1280.68 388.201 1280.49 388.397 1280.18 387.921C1279.94 387.567 1279.93 386.704 1279.84 386.289C1279.53 384.998 1279.16 383.724 1278.69 382.482C1277.1 378.247 1274.42 374.498 1271.2 371.341C1265.17 365.434 1257.01 361.357 1248.55 360.619C1243.91 360.216 1239.31 360.969 1234.93 362.477C1232.66 363.258 1230.46 364.231 1228.32 365.306C1227.67 365.629 1225.58 367.214 1224.93 367.111C1224.22 366.998 1222.78 365.22 1222.2 364.774C1215.01 359.259 1206.14 357.09 1197.19 357.156C1187.09 357.231 1177.36 357.736 1168.94 363.897C1167.15 365.202 1165.45 366.63 1163.84 368.134C1162.98 368.925 1162.16 369.747 1161.37 370.602C1160.9 371.118 1160.44 371.646 1159.99 372.188C1159.24 373.108 1159.36 373.41 1158.3 372.768C1154.25 370.304 1149.55 369.151 1144.81 369.733C1142 370.079 1139.27 370.923 1136.67 372.034C1135.79 372.412 1133.74 373.921 1132.8 373.935C1131.87 373.95 1129.85 372.551 1128.89 372.196C1123.69 370.275 1118.08 369.802 1112.62 370.689C1106.98 371.605 1101.44 373.856 1096.66 376.965C1094.37 378.461 1092.36 380.119 1090.75 382.343C1090.06 383.303 1089.43 384.319 1088.64 385.21C1088.18 385.731 1087.26 386.266 1087.02 386.926C1087.17 386.531 1080.85 384.096 1080.26 383.94C1077.08 383.111 1073.85 383.279 1070.74 384.302C1064.9 386.226 1059.87 390.542 1055.74 394.966C1053.62 397.239 1051.76 399.751 1050.18 402.428C1049.43 403.71 1048.74 405.028 1048.11 406.375C1047.8 407.027 1047.6 407.843 1047.19 408.431C1046.67 409.188 1046.32 409.203 1045.38 409.533C1040.6 411.209 1036.24 414.047 1032.92 417.882C1029.56 421.761 1027.38 426.539 1026.47 431.57C1026.41 431.866 1026.38 433.095 1026.21 433.255C1025.97 433.476 1025.01 433.378 1024.64 433.421C1023.38 433.569 1022.13 433.789 1020.9 434.081C1018.62 434.62 1016.41 435.413 1014.31 436.451C1006.14 440.494 1000.3 448.074 997.443 456.603C994.443 465.554 994.496 475.81 998.082 484.594C998.661 486.012 999.35 487.39 1000.16 488.692C1000.66 489.492 1000.82 489.494 1000.49 490.333C1000.13 491.267 999.477 492.174 999.05 493.086C997.656 496.062 996.682 499.219 996.067 502.444C995.057 507.733 994.557 513.291 995.553 518.621C996.015 521.095 996.821 523.515 998.05 525.719C998.677 526.842 999.41 527.908 1000.24 528.894C1000.67 529.406 1001.12 529.895 1001.6 530.363C1001.88 530.631 1002.23 530.865 1002.47 531.164C1003.03 531.893 1003.15 531.294 1002.86 532.364C1002.45 533.86 1001.52 535.335 1000.96 536.791C1000.37 538.291 999.844 539.812 999.36 541.348C998.381 544.457 997.554 547.623 997.036 550.843C996.042 557.026 996.217 563.614 999.14 569.288C1000.39 571.715 1002.18 573.844 1004.36 575.501C1005.42 576.311 1006.57 577.009 1007.78 577.583C1008.41 577.878 1009.2 578.005 1009.48 578.606C1009.79 579.253 1009.33 580.536 1009.23 581.259C1008.33 587.548 1007.88 594.15 1009.75 600.313C1011.47 605.989 1015.26 611 1020.18 614.318C1029.72 620.754 1042.59 620.391 1052.61 615.239C1055.23 613.895 1057.67 612.228 1059.85 610.261C1065.41 617.742 1076.84 617.505 1084.96 615.373C1095.07 612.718 1103.19 605.682 1107.86 596.437C1114.26 604.224 1127.68 601.697 1132.11 593.25C1133.19 591.182 1133.84 588.903 1134.15 586.597C1134.32 585.385 1134.21 584.162 1134.34 582.959C1134.5 581.426 1135.52 579.936 1136.11 578.453C1137.26 575.568 1137.97 572.586 1138 569.474C1138.02 567.848 1137.81 566.264 1137.66 564.652C1137.52 563.201 1137.92 561.849 1138.15 560.416C1135.55 560.844 1132.39 560.144 1129.95 559.391C1127.55 558.653 1125.3 556.708 1123.61 554.932C1119.68 550.807 1117.28 545.401 1115.64 540.019C1112.03 528.208 1113.51 514.038 1125.39 507.556C1130.92 504.536 1147.49 504.546 1154.08 506.038C1161 507.608 1168.86 522.9 1169.24 524.338C1169.48 525.227 1169.36 526.328 1170.18 526.921C1171.97 528.224 1174.94 525.963 1176.26 524.846C1178.54 522.92 1180.17 520.356 1181.59 517.758C1184.66 512.097 1187.14 506.026 1188.89 499.829C1190.24 495.052 1191.11 490.125 1192.87 485.469C1194.63 480.836 1197.4 476.695 1201.7 474.071C1206.38 471.215 1211.75 469.712 1216.89 467.918C1221.99 466.139 1226.99 463.966 1230.94 460.193C1231.81 459.363 1232.66 458.482 1233.35 457.505C1233.91 456.734 1234.45 455.258 1235.29 454.769C1236.6 454.008 1238.51 455.986 1239.64 456.704C1245.21 460.248 1249.87 465.19 1253.62 470.589C1257.35 475.958 1260.41 481.125 1262.9 487.12C1264.75 491.567 1265.9 497.262 1269.14 500.906C1270.59 502.533 1281.37 503.518 1284.85 502.097C1288.34 500.676 1292.25 496.988 1293.43 494.676C1294.62 492.31 1294.91 489.711 1294.4 487.12C1294.1 485.596 1293.48 484.173 1293.15 482.676C1292.86 481.419 1292.6 480.23 1291.99 479.078C1290.83 476.896 1288.85 475.327 1286.46 474.671C1288.95 472.378 1291.01 469.635 1292.43 466.569C1293.92 463.383 1295.17 459.509 1295.53 456.013C1295.82 453.173 1295.37 450.231 1293.82 447.79C1292.19 445.23 1289.3 443.56 1286.8 441.963C1290.62 438.976 1293.88 435.343 1296.57 431.32C1301.79 423.498 1305.02 413.637 1302.37 404.312Z",
    fill: "#44382D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1062.59 1088.14L1215.7 1625.72L1327.42 2021.94H1408.9L1290.19 1088.14H1062.59Z",
    fill: "#894B71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1021.64 1088.14C1018.1 1365.22 1006.02 1516.34 1002.3 1541.51C998.584 1566.69 942.358 1726.83 833.625 2021.94H918.034C1056.46 1738.83 1133.73 1578.69 1149.85 1541.51C1165.97 1504.34 1215.72 1353.21 1290.65 1088.14H1021.64Z",
    fill: "#A05985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1431.49 744.577L1284.89 824.902L1339.03 883.032L1445.54 785.459C1501.66 769.987 1527.32 758.669 1522.53 751.504C1518.49 745.463 1511.97 745.673 1505.97 745.866C1501.3 746.017 1496.93 746.157 1494.3 743.325C1488.27 736.857 1499.77 714.241 1511.59 693.246C1523.41 672.251 1510.77 674.078 1503.54 677.098C1479.88 693.122 1455.86 715.615 1431.49 744.577ZM1578.87 857.285L1514.48 892.675L1518.15 957.325C1518.15 957.325 1559.85 927.21 1595.73 917.201C1641.48 904.44 1659.99 894.694 1682.35 866.196C1694.31 850.948 1704.46 820.296 1693.07 810.314C1688.71 806.485 1672.43 815.531 1655.83 824.762C1643.18 831.796 1630.33 838.938 1622.42 840.568C1611.76 842.763 1613.01 828.947 1614.01 817.907C1614.72 809.984 1615.31 803.491 1611.28 805.369C1592.43 805.692 1578.87 857.285 1578.87 857.285Z",
    fill: "#EAC7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1213.5 807.009C1264.85 806.466 1333.32 795.616 1406.38 749.22L1435.07 813.234C1384.67 863.269 1313.82 904.379 1251.86 902.638C1203.03 901.266 1178.08 842.18 1213.5 807.009Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.02 1245.57C1026.21 1239.2 981.356 1233.35 954.776 1238.59C924.953 1141.69 949.717 1080.68 972.578 1024.36C986.356 990.413 999.442 958.171 999.47 920.803C999.552 811.981 1086.89 644.479 1099.74 644.479H1103.43H1205.26H1216.92C1222.16 711.82 1244.52 784.731 1267.03 858.111C1272.28 875.248 1277.54 892.41 1282.6 909.532C1367.76 928.873 1556.87 861.55 1556.87 861.55C1556.87 861.55 1604.61 960.36 1601 1002.44C1490.93 1059.96 1396.59 1085.61 1318.87 1087.3C1321.34 1133.44 1315.73 1177.35 1296.87 1217.46C1271.6 1271.21 1166.38 1257.49 1075.02 1245.57Z",
    fill: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_45",
    x1: 1571.08,
    y1: 679,
    x2: 1928.69,
    y2: 679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_503_45",
    x1: 15.0056,
    y1: 60.0001,
    x2: 282.179,
    y2: 60.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_503_45",
    x1: 6.23311,
    y1: 60.0001,
    x2: 117.213,
    y2: 60.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_503_45",
    x1: 1723.7,
    y1: 859,
    x2: 1949.77,
    y2: 859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_503_45",
    x1: 1676.79,
    y1: 1399,
    x2: 1957.94,
    y2: 1399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D72FE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D72FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.6983d596f64f5a6fde2c3d932f89ee85.svg";
export { ForwardRef as ReactComponent };